import * as api from "../api";
import toast from "react-hot-toast";
import dayjs from "dayjs";
import { DateFormatter2 } from "../../helpers/DateFormatter2";
export const GET_COLLECTOR_SUCCESS = "GET_COLLECTOR_SUCCESS";
export const GET_INDIVIDUAL_COLLECTOR = "GET_INDIVIDUAL_COLLECTOR";
export const CLEAR_INDIVIDUAL_COLLECTOR = "CLEAR_INDIVIDUAL_COLLECTOR";

const convertToArrayCollector = (responseData) => {
  let dataArray = [];

  responseData.forEach((item) => {
    const formattedDate =
      item.lastBatchDate === null ? "-" : DateFormatter2(item.lastBatchDate);
    const tempArray = [
      item.id,
      item.username,
      item.name,
      item.email,
      item.mobileNumber,
      item.totalAssignedCustomer,
      item.isActive ? "Active" : "InActive",
      formattedDate,
      item.id,
    ];
    dataArray = [...dataArray, tempArray];
  });
  return dataArray;
};

export const createCollector =
  (payload, handleSuccess, handleFailure) => async (dispatch, getState) => {
    try {
      const {
        user: { accessToken },
        user: {
          userData: {
            sahakari: { name },
          },
        },
      } = getState();
      const sahakariName = name;
      const data = {
        ...payload,
        sahakariName,
      };

      const response = await api.apiCreateCollector(data, accessToken);
      handleSuccess();
    } catch (err) {
      handleFailure(err);
    }
  };

export const getCollectors =
  (isActive = false) =>
  async (dispatch, getState) => {
    try {
      const {
        user: { accessToken },
      } = getState();
      let response;
      if (isActive) {
        response = await api.apiGetActiveCollector(accessToken);
      } else {
        response = await api.apiGetCollector(accessToken);
      }

      const finalCollectorArray = convertToArrayCollector(response.data);

      dispatch({ type: GET_COLLECTOR_SUCCESS, payload: finalCollectorArray });
    } catch (err) {
      console.log(err);
      console.log(err.response?.data?.message, "2");
      console.log(err?.response, "3");
      toast.error("Error getting Collector. Please refresh ");
    }
  };

export const getCollectorById =
  (id, handleSuccess, handleFailure) => async (dispatch, getState) => {
    try {
      const {
        user: { accessToken },
      } = getState();
      const response = await api.apiGetCollectorById(accessToken, id);
      dispatch({ type: GET_INDIVIDUAL_COLLECTOR, payload: response.data });
      handleSuccess(response.data);
    } catch (err) {
      toast.error(err.response ? err.response.data?.message : err.message);

      handleFailure();
    }
  };

export const clearIndividualCollector = () => {
  return { type: CLEAR_INDIVIDUAL_COLLECTOR };
};

export const updateCollector =
  (payload, handleSuccess, handleFailure) => async (dispatch, getState) => {
    try {
      const {
        user: { accessToken },
      } = getState();
      const response = await api.apiUpdateCollector(accessToken, payload);
      handleSuccess();
    } catch (err) {
      toast.error(err.response ? err.response.data?.message : err.message);
      handleFailure();
    }
  };

export const transferCollectorCustomers =
  (oldCollectorId, newCollectorId) => async (dispatch, getState) => {
    try {
      const {
        user: { accessToken },
      } = getState();
      const response = await api.apiTransferCollectorCustomers(
        accessToken,
        oldCollectorId,
        newCollectorId
      );
      toast.success("Successfully transfered the customers");
    } catch (err) {
      toast.error(err.response ? err.response.data?.message : err.message);
    }
  };
